import type { ICourseSetting } from "@/scripts/application/types";

const SUBSCRIPTION_KINDS = ["subscription", "individual_subscription"];

// Months that one billing period of this plan covers. Stripe-style
// subscriptions derive months from `subscription_interval` (`amount` is the
// price per interval). Non-subscription kinds (licence etc.) use `duration`.
export function planMonths(course_setting: ICourseSetting): number {
  if (SUBSCRIPTION_KINDS.includes(course_setting.kind)) {
    switch (course_setting.subscription_interval) {
      case "year":
        return 12;
      case "quarter":
        return 3;
      case "week":
        return 0.25;
      case "day":
        return 1 / 30;
      default:
        return 1;
    }
  }
  return course_setting.duration || 1;
}
